import React from 'react';
import qs from 'query-string';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import * as yup from 'yup';
import styled from 'styled-components';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import Form from './Form';
import FieldSet from './FieldSet';
import Input from './Input';
import Textarea from './Textarea';
import PrivacyPolicyCheckbox from './PrivacyPolicyCheckbox';
import { LoadingButton } from '../Buttons';

const StyledInuiryForm = styled.div`
  margin: 0 auto;
  max-width: ${p => p.theme.globalWidthSmall};
`;

const Row = styled.div`
  display: flex;
  margin: 0 -${p => p.theme.gutterXSmall};
`;

const Column = styled.div`
  flex: 1;
  margin: 0 ${p => p.theme.gutterXSmall} 30px ${p => p.theme.gutterXSmall};
`;

yup.setLocale({
  mixed: {
    required: 'Dette feltet er obligatorisk.'
  },
  string: {
    email: 'Du må skrive inn en gyldig e-postadresse.',
    url: 'Du må skrive inn en gyldig nettadresse.',
    max: 'Du kan maks skrive inn ${max} tegn.' // eslint-disable-line no-template-curly-in-string
  }
});

const mapValuesToFields = values => {
  const fields = [
    {
      key: 'input_7',
      value: values.name || null
    },
    {
      key: 'input_6',
      value: values.email || null
    },
    {
      key: 'input_3',
      value: values.phone || null
    },
    {
      key: 'input_4',
      value: values.subject || null
    },
    {
      key: 'input_5',
      value: values.message || null
    }
  ];

  return fields;
};

function ContactForm({ location, formId }) {
  const query = qs.parse(location.search);

  return (
    <StyledInuiryForm>
      <Mutation
        mutation={gql`
          mutation submitForm($submission: GFFormSubmission $id: Int) {
              submission:postGFFormSubmission(
                id: $id
                submission: $submission
              ){
                is_valid
                page_number
                source_page_number
                confirmation_message
              }
            }
        `}
      >
        {(submit, { loading, error, data }) => <Formik
          initialValues={{
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            accepted: false
          }}
          validationSchema={yup.object().shape({
            name: yup.string().required(),
            email: yup
              .string()
              .email()
              .required(),
            phone: yup.string(),
            subject: yup.string().required(),
            message: yup
              .string()
              .required()
              .max(500),
            accepted: yup
              .bool()
              .oneOf([true], 'Du må godkjenne personvernerklæringen.')
          })}
          onSubmit={(values, { setSubmitting }) => {
            submit({
              variables: {
                id: formId,
                submission: {
                  fields: mapValuesToFields(values)
                }
              }
            }).catch((error) => {
              console.error(error);

              setSubmitting(false);
            }).then((data) => {
              setSubmitting(false);
            });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => <div>
              {(data && data.submission) && <div
                dangerouslySetInnerHTML={{
                  __html: data.submission.confirmation_message
                }}
              ></div>}

              {!(data && data.submission) && <Form onSubmit={handleSubmit}>
                {error && <div>
                  {error.toString()}
                </div>}
                <FieldSet disabled={isSubmitting}>
                  <Row>
                    <Column>
                      <Input
                        name="name"
                        label="Navn/Bedrift m/kontaktperson"
                        isRequired={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        error={errors.name}
                        touched={touched.name}
                      />
                    </Column>
                  </Row>

                  <Row>
                    <Column>
                      <Input
                        type="email"
                        name="email"
                        label="E-post"
                        isRequired={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        error={errors.email}
                        touched={touched.email}
                      />
                    </Column>

                    <Column>
                      <Input
                        name="phone"
                        label="Telefon"
                        isRequired={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone}
                        error={errors.phone}
                        touched={touched.phone}
                      />
                    </Column>

                    <Column>
                      <Input
                        name="subject"
                        label="Emne"
                        isRequired={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.subject}
                        error={errors.subject}
                        touched={touched.subject}
                      />
                    </Column>

                  </Row>

                  <Row>
                    <Column>
                      <Textarea
                        name="message"
                        label="Melding"
                        isRequired={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.message}
                        error={errors.message}
                        touched={touched.message}
                      />
                    </Column>
                  </Row>

                  <Row>
                    <Column>
                      <PrivacyPolicyCheckbox
                        name="accepted"
                        value={values.accepted}
                        checked={values.accepted}
                        error={errors.accepted}
                        touched={touched.accepted}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Column>
                  </Row>
                </FieldSet>

                <LoadingButton type="submit" loading={isSubmitting}>
                  Send inn
                </LoadingButton>
              </Form>}
            </div>}
        </Formik>}
      </Mutation>
    </StyledInuiryForm>
  );
}

export default withRouter(ContactForm);
